export default {
    INPOST: 'boldshippinginpost',
    PICKUP: 'payonpickup',
    DPD: 'boldshippingdpd',
    CASTO: 'boldshippingcastorama',
    DTS: 'boldshippingdtsdc',
};
